import React from 'react'

function About(props) {
    return (
        <>
            <p className="heading-text"> ABOUT ME </p>
            <p className="para-text">
                {(props.dob !== '' && props.dob !== undefined && props.dob !== null) ? <span>Date of Birth: {props.dob}<br/></span>:<></>}
                {(props.age !== '' && props.age !== undefined && props.age !== null) ? <span>Age: {props.age}<br/></span>:<></>}
                {(props.gender !== '' && props.gender !== undefined && props.gender !== null) ? <span>Gender: {props.gender}<br/></span>:<></>}
                {(props.birthplace !== '' && props.birthplace !== undefined && props.birthplace !== null) ? <span>Birth Place: {props.birthplace}</span>:<></>}
            </p>
        </>
    )
}

export default About
